import { Expose } from 'class-transformer';
import { BaseUUIDEntity } from './base.entity';

export class ClaimInstallationEntity extends BaseUUIDEntity {
  @Expose()
  public registrationCode: string;
}
